import axios from 'axios';
import React, { useEffect, useState } from 'react'
import QRCode from 'react-qr-code';
import auth from '../helpers/auth';
import { useLocation } from 'react-router-dom';
import { useHistory } from 'react-router-dom';

/**
 * Setup2FA component
 */
const Setup2FA = () => {
    // const { state } = this.props.location;

    const [otpauth, setOtpAuth] = useState("");
    const [code, setCode] = useState("");
    const history = useHistory();
    const location = useLocation();
    const { email, password } = location.state || {};
    useEffect(() => {
        const config = {
            headers: { Authorization: `Bearer ${auth.token}` }
        };

        axios
            .post(`${process.env.REACT_APP_API_URL}enable_2fa`, { "headers": { "Access-Control-Allow-Origin": "*" }, email, password }, config)
            .then((response) => {
                // console.log("enable-2fa response:: ", response.data);
                setOtpAuth(`otpauth://totp/${email}?secret=${response.data.secret}&issuer=Birdprotect.ai`);
            })
            .catch((error) => {
                console.error("Error enabling 2FA", error);
            });
    }, []);

    const handleSubmit = () => {
        if (code.length !== 6) {
            alert("Please enter a valid 6-digit code.");
            return;
        } else {
            const config = {
                headers: { Authorization: `Bearer ${auth.token}` }
            };

            axios.post(process.env.REACT_APP_API_URL + `verify_2fa_setup`, {
                email, password, totpCode: code
            }, config)
                .then(response => {
                    history.push('/');

                    // setTimeout(() => this.setState({
                    //     success: true,
                    //     refilling: false
                    // }), 200)
                    // this.setAlert('success', 'Your 2FA has been registered')
                })
                .catch(error => {
                    console.log("ERROR: got error")
                    console.log("RESPONSE  >   ", error);
                });
        }
        // Add your actual verification logic here
    };

    return (
        <div style={pageStyle}>
            <div style={containerStyle}>
                <h2 style={headingStyle}>Set up an authenticator app</h2>
                <p style={paragraphStyle}>
                    Authenticator apps make 2FA more convenient while maintaining security.{" "}
                    Please make sure you set it up!
                </p>
                {email && <div>
                    <div style={stepContainer}>
                        <div style={stepNumber}>1.</div>
                        <div style={stepText}>
                            Download an authenticator app like Google or Microsoft Authenticator.
                        </div>
                    </div>
                    <div style={stepContainer}>
                        <div style={stepNumber}>2.</div>
                        <div style={stepText}>
                            Scan the QR code below using your authenticator app:
                            {/* <div style={qrBox}>[QR Code]</div> */}
                            <br></br>
                            <br></br>
                            <QRCode
                                size={256}
                                style={{ height: "auto", maxWidth: "250px", width: "250px" }}
                                value={otpauth}
                                viewBox={`0 0 256 256`}
                            />
                        </div>
                    </div>
                    <div style={stepContainer}>
                        <div style={stepNumber}>3.</div>
                        <div style={stepText}>
                            Enter the 6-digit code generated by your app to verify setup.
                            <div>
                                <input
                                    type="text"
                                    maxLength="6"
                                    value={code}
                                    onChange={(e) => setCode(e.target.value)}
                                    placeholder="Enter code"
                                    style={inputStyle}
                                />
                            </div>
                        </div>
                    </div>
                    <div style={buttonContainerStyle}>
                        <button style={buttonStyle} onClick={handleSubmit}>
                            Continue
                        </button>
                    </div>
                </div>
                }
                {!email &&
                    <div>
                        <div style={stepContainer}>
                            <div style={stepText}>
                                Please authenticate, so you can continue the setup.
                            </div>
                        </div>
                        <div style={buttonContainerStyle}>
                            <button style={buttonStyle} onClick={() => window.location = '/'}>
                                Login
                            </button>
                        </div>
                    </div>
                }
            </div>
        </div>
    );
}

const pageStyle = {
    height: "100%",
    width: "100%",
    padding: "94px 0 50px 0",
    backgroundColor: "#1d1f37"
}
const containerStyle = {
    maxWidth: "500px",
    margin: "40px auto",
    padding: "24px",
    borderRadius: "12px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    fontFamily: "Arial, sans-serif",
    backgroundColor: "#fff",
};

const headingStyle = {
    color: "rgb(0, 0, 0)",
    fontSize: "20px",
    fontWeight: "bold",
    marginBottom: "12px",
};

const paragraphStyle = {
    fontSize: "14px",
    color: "#555",
    marginBottom: "16px",
};

const stepContainer = {
    marginBottom: "16px",
    display: "flex",
    alignItems: "flex-start",
    gap: "10px",
};

const stepNumber = {
    fontWeight: "bold",
    fontSize: "16px",
};

const stepText = {
    fontSize: "14px",
    color: "#333",
};

const inputStyle = {
    padding: "8px",
    fontSize: "14px",
    width: "150px",
    border: "1px solid #ccc",
    borderRadius: "4px",
    marginTop: "8px",
    outline: "1px solid rgb(36 40 70)"
};
const buttonContainerStyle = {
    display: "flex",
    justifyContent: "center"
};

const buttonStyle = {
    padding: "10px 16px",
    backgroundColor: "#242846",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "14px",
    marginTop: "20px",
};

export default Setup2FA;

